<template>
  <v-container fluid class="px-lg-5">
    <table-filter @filterTable="onYearFilter" :items="yearOptions"
      :label="$t('models.appraisal.attributes.year')" />
    <v-card class="rounded-card" flat outlined>
      <v-data-table :headers="headers" :items="appraisals.items" :options.sync="options"
        @update:options="updateOptions" :server-items-length="appraisals.count" :loading="loading"
        :no-data-text="$t('messages.emptyState', { entity: $tc('models.appraisal.entity', 2) })"
        :no-results-text="$t('messages.emptyState', { entity: $tc('models.appraisal.entity', 2) })" flat>
        <template v-slot:item="{ item }">
          <tr class="appraisal-row--clickable" @click="openAppraisal(item)">
            <td>{{ item.title }}</td>
            <td>
              <v-chip small :color="statusColors[item.status]" text-color="white">
                {{ $t(`models.appraisal.attributes.statuses.${item.status}`) }}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {appraisalStatusColors} from 'constants';

export default {
  name: 'UserAppraisals',
  data() {
    const currentYear = new Date().getFullYear();
    return {
      yearOptions: [currentYear, currentYear - 1, currentYear - 2],
      statusColors: appraisalStatusColors,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        mustSort: ['true'],
        multiSort: false,
        filterBy: {
          year: currentYear
        }
      },
      headers: [
        {
          text: this.$t('models.appraisal.attributes.title'),
          value: 'title',
          sortable: false
        },
        {
          text: this.$t('models.appraisal.attributes.status'),
          value: 'status',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['appraisals', 'currentUser']),
    employeeId() {
      return this.$route.params.uuid === 'me' ? this.currentUser.id : this.$route.params.uuid;
    }
  },
  methods: {
    ...mapActions(['getAppraisals']),
    updateOptions(options) {
      this.loading = true;
      this.getAppraisals({...options, filterBy: {...options.filterBy, employeeId: this.employeeId}})
        .then(() => (this.loading = false));
    },
    onYearFilter(year) {
      this.options.page = 1;
      this.options.filterBy.year = year;
      this.updateOptions(this.options);
    },
    openAppraisal(appraisal) {
      this.$router.push({name: 'Appraisal', params: {id: appraisal.id}});
    }
  }
};
</script>

<style>
.appraisal-row--clickable {
  cursor: pointer;
}

.appraisal-row--clickable .v-chip {
  cursor: pointer;
}
</style>
